import { Text } from '@dixa/lib-shared-habla';
import {
  AutomationActivityType,
  AutomationCustomAttributesNodeVisitedLogEntry,
  isAutomationCustomAttributesNodeOutcomeError,
} from 'lib-shared-types-api';
import groupBy from 'lodash/groupBy';

type RoutedThroughCustomAttributesProps = {
  node: AutomationCustomAttributesNodeVisitedLogEntry;
};
export function RoutedThroughCustomAttribute({
  node,
}: RoutedThroughCustomAttributesProps): JSX.Element {
  const { activity_type, outcomes } = node;
  const customAttributeLabel =
    activity_type ===
    AutomationActivityType.AUTOMATION_CONVERSATION_CUSTOM_FIELDS_NODE_VISITED
      ? 'Conversation attribute'
      : 'Contact attribute';

  const groupedOutcomes = groupBy(outcomes, (outcome) =>
    isAutomationCustomAttributesNodeOutcomeError(outcome) ? 'error' : 'success',
  );
  const outcomeText = Object.entries(groupedOutcomes)
    .map(([key, value]) => {
      if (key === 'error') {
        const errorText = value.length === 1 ? 'error' : 'errors';
        return `${value.length} ${errorText}`;
      }
      const successText =
        value.length === 1 ? 'attribute updated' : 'attributes updated';
      return `${value.length} ${successText}`;
    })
    .join(' and ');

  return (
    <Text.Paragraph>
      {customAttributeLabel} · {outcomeText}
    </Text.Paragraph>
  );
}
